'use strict';

function PerformanceReviewAgreementQuestionnaireController(performanceReviewService, errorHandlerService, $location, $modal, $route, $q) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.$onDestroy = $onDestroy;
  vm.stepChange = stepChange;

  vm.stepChangeOk = stepChangeOk;
  vm.stepChangeFailed = stepChangeFailed;
  vm.hasRole = hasRole;

  vm.claimFirstTurn = claimFirstTurn;
  vm.isFirstTurn = isFirstTurn;
  vm.isCurrentUserTurn = isCurrentUserTurn;
  vm.isAllComplete = isAllComplete;
  vm.showTargets = showTargets;

  function $onInit() {
    vm.max = vm.data.max;
    vm.current = vm.data.current || 0;
    vm.answers = vm.data.answers || [];
    vm.question = vm.data.question;
    vm.choices = vm.data.question.choices;
    vm.round = vm.data.round;
    vm.user = vm.data.user || {};

    vm.choice = vm.data.question.answer.choice;
    vm.reflection = vm.data.question.answer.reflection;
    vm.when = vm.data.question.answer.when;
    vm.what = vm.data.question.answer.what;
    vm.how = vm.data.question.answer.how;
    vm.reviewComments = vm.data.question.answer.review_comments;
    vm.isReview = vm.data.review;

    vm.answer = vm.data.answer;
    vm.turn = vm.data.turn;

    vm.didStepChange = false;
    vm.getPanelClass = getPanelClass;
  }

  function $onDestroy() {
    if (vm.didStepChange === false) {
      updateCurrentAnswer();
    }
  }

  function updateCurrentAnswer() {
    if (vm.isCurrentUserTurn()) {
      return performanceReviewService.update
        .answer(vm.data.question.answer.id, vm.choice, vm.reflection, vm.what, vm.how, vm.when, vm.reviewComments);
    }

    return $q.resolve();
  }

  function stepChange(to) {
    return updateCurrentAnswer()
      .then(vm.stepChangeOk(to))
      .catch(vm.stepChangeFailed(to));
  }

  function stepChangeOk(to) {
    vm.didStepChange = true;
    return function okResponse(response) {
      $location.path(performanceReviewService.urls.agreement.questionnaire.step({token: vm.data.token, step: to}));
      return response;
    };
  }

  function stepChangeFailed(to) {
    return function failedResponse(error) {
      var modal = $modal({
        template: require('./performance-review-agreement-questionnaire.modal.html'),
        show: true,
        locals: {to: to}
      });
      errorHandlerService.updateModalError(modal, error);
      return error;
    };
  }

  function hasRole(role) {
    return vm.me.groups
      .map(function (group) {
        return group.name;
      })
      .some(function (groupName) {
        return groupName === role;
      });
  }

  function claimFirstTurn() {
    return function (promise) {
      return promise.finally($route.reload);
    };
  }

  function isFirstTurn() {
    return vm.turn.user === null;
  }

  function isCurrentUserTurn() {
    return vm.turn.self === true;
  }

  function isAllComplete() {
    if (vm.turn.lock) {
      return false;
    }
    return !vm.answers.some(function (answer) {
      return answer.state !== 'COMPLETE';
    });
  }

  function getPanelClass() {
    if (vm.isReview) {
      return 'panel-warning';
    }
    return 'panel-info';
  }

  function showTargets() {
    if (vm.turn.lock) {
      return true;
    }
    return !vm.isReview;
  }
}

module.exports = PerformanceReviewAgreementQuestionnaireController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-agreement-questionnaire/performance-review-agreement-questionnaire.controller.js
 ** module id = 296
 ** module chunks = 0
 **/